'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import Image from 'next/image';
import WindowSize from '@/utils/windowSize';

const AuthorArticles = ({ authorName, articlesData }) => {
  const windowSize = WindowSize();
  const pageSize = windowSize.width >= 640 ? 10 : 5;
  const [articles, setArticles] = useState(() =>
    articlesData.slice(0, pageSize)
  );
  const [prevDeps, setPrevDeps] = useState({ articlesData, pageSize });

  if (
    articlesData !== prevDeps.articlesData ||
    pageSize !== prevDeps.pageSize
  ) {
    setPrevDeps({ articlesData, pageSize });
    setArticles(articlesData.slice(0, pageSize));
  }

  const hasMore = articles.length < articlesData.length;

  const loadMoreArticles = () => {
    setArticles((prev) => [
      ...prev,
      ...articlesData.slice(prev.length, prev.length + pageSize)
    ]);
  };

  return (
    <section className="bg-dawn-grey-20 py-15" data-name="author-articles">
      <div className="mx-auto max-w-200 px-5 lg:px-0">
        <p className="h3">{`${authorName}'s Articles`}</p>

        <div className="grid grid-cols-1 gap-6 md:grid-cols-2">
          {articles.map((article, index) => {
            const { url, feature_image, title, categoryConnection } =
              article ?? {};
            if (!url || !feature_image || !title || !categoryConnection) {
              console.warn(
                'Article Preview is missing required fields:',
                article
              );
              return null;
            }

            return (
              <div className="" key={index}>
                <div className="mt-4 mb-5 lg:mb-6">
                  {feature_image.url && (
                    <Link href={url} prefetch={false}>
                      <Image
                        src={feature_image.url}
                        height="243"
                        width="368"
                        sizes="(min-width: 1280px) 368px, (min-width: 1024px) 310px, (min-width: 768px) 328px, (min-width: 640px) 264px, 607px"
                        style={{ height: 243, width: '100%' }}
                        alt={
                          feature_image.title?.replace(/\.[^/.]+$/, '') ||
                          `${title} Featured Image`
                        }
                        className="cursor-pointer bg-white object-cover transition delay-100 ease-in-out hover:opacity-60"
                      />
                    </Link>
                  )}
                </div>
                <p className="preheading-s text-parlor-green mb-2">
                  {categoryConnection.title}
                </p>
                <h2 className="h5 hover:text-cozy-cognac text-black">
                  <Link href={url} prefetch={false}>
                    {title}
                  </Link>
                </h2>
              </div>
            );
          })}
        </div>

        {hasMore && (
          <button
            className="btn-secondary body-r mx-auto mt-12.5 block h-12 w-45"
            onClick={loadMoreArticles}
          >
            Load More
          </button>
        )}
      </div>
    </section>
  );
};

export default AuthorArticles;
